import React, { useEffect, useState } from "react";
import logo from "./../../assets/images/muyeed_logo_2.png";

import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getAllMenu, getMenus } from "../../redux/menu/menuSlice";
import {
  setCurrentSelectedMenuID,
  getCurrentSelectedMenuID,
} from "../../redux/menu/menuWisePageConfigSlice";
import {
  getScreenSize,
  getSideMenuStatus,
  setSideMenuStatus,
} from "../../redux/theme/themeSlice";
import MobileMenu from "./MobileMenu";

const Navbar = () => {
  const dispatch = useDispatch();

  const isCollapsed = useSelector(getSideMenuStatus);
  const menuList = useSelector(getAllMenu);
  const currentMenuID = useSelector(getCurrentSelectedMenuID);
  const clickedMenu = useSelector(getCurrentSelectedMenuID);
  const screenSize = useSelector(getScreenSize);
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    if (screenSize < 1024) setIsOpen(true);
    else setIsOpen(false);
  }, [screenSize]);

  useEffect(() => {
    dispatch(getMenus());
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleSidebarCollapse = (e) => {
    e.preventDefault();
    dispatch(setSideMenuStatus(!isCollapsed));
  };
  const handleMenuClick = (e, id) => {
    dispatch(setCurrentSelectedMenuID(id));
    dispatch(setCurrentSelectedMenuID(id));
  };

  // Update the Navbar to make the text color white on scroll
  return (
    <>
      {!isOpen ? (
        <nav
          className={`py-4 sticky top-0 z-50 shadow-md transition-all duration-300 ${
            isScrolled ? "bg-sky-500 text-white" : "bg-transparent text-gray-700"
          }`}
        >
          <div className="container mx-auto flex justify-start items-center">
            {/* Navigation Links */}
            <ul className="flex space-x-6">
              {menuList &&
                menuList.length > 0 &&
                menuList.map((item) => (
                  <Link
                    key={item.id}
                    to={`${item.menu_path}`}
                    className={`hover:text-indigo-600 transition-colors duration-300 ${
                      isScrolled ? "text-white" : "text-gray-700"
                    }`}
                  >
                    <li
                      className={`${
                        item.id == clickedMenu
                          ? "border-b-2 border-indigo-600"
                          : ""
                      } py-2`}
                      onClick={(e) => handleMenuClick(e, item.id)}
                    >
                      {item.menu_name}
                    </li>
                  </Link>
                ))}
            </ul>
          </div>
        </nav>
      ) : (
        <MobileMenu />
      )}
    </>
  );
};

export default Navbar;
